// extracted by mini-css-extract-plugin
export default {"tpfield":"tappay_tpfield__VFzed","error":"tappay_error__0vIke","success":"tappay_success__-tZsD"};